<template>
	<div style="width: 100%;height: 100%;">
		<div style="background-color: white;font-size: 18px;height: 50px;line-height: 50px;text-align: center;padding-right: 30px;border-bottom: 1px solid #F6F6F6;">
			<img @click="toIndex()" src="../../assets/fImage/zuojiantou.png" style="float: left;padding-left: 10px;height: 20px;width: 20px;padding-top: 15px;">
			调理人信息
		</div>
		<div style="background-color: white;">
			<div style="height: 50px;line-height: 50px;width: 100%;border-bottom: 1px solid #F6F6F6;">
				<div style="float: left;width: 50px;margin-left: 5%;font-size: 16px;">姓名</div>
				<input v-model="name" :disabled="item.id?true:false" style=" font-size: 16px;margin-right: 5%;;margin-top: 10px;float: right;width: calc(90% - 60px);text-align: right;border: 0;height: 20px;line-height: 20px;padding: 5px;" placeholder="请填写调理人姓名">
			</div>
			<div style="height: 50px;line-height: 50px;width: 100%;border-bottom: 1px solid #F6F6F6;">
				<div style="float: left;width: 100px;margin-left: 5%;font-size: 16px;">生日(阳历)</div>
				<img src="../../assets/fImage/youjiantou.png" style="float: right;width: 10px;height: 10px;margin-top: 20px;margin-right: 5%;">
				<input v-model="birthday" @click="showTime(true)" style=" font-size: 16px;;margin-top: 10px;float: right;width: calc(90% - 130px);text-align: right;border: 0;height: 20px;line-height: 20px;padding: 5px;" readonly placeholder="请选择出生年月日">
			</div>
			<div style="height: 50px;line-height: 50px;width: 100%;border-bottom: 1px solid #F6F6F6;">
				<div style="float: left;width: 100px;margin-left: 5%;font-size: 16px;">生日(阴历)</div>
				<img src="../../assets/fImage/youjiantou.png" style="float: right;width: 10px;height: 10px;margin-top: 20px;margin-right: 5%;">
				<input v-model="lunarCalendar" @click="showTime(false)" style=" font-size: 16px;;margin-top: 10px;float: right;width: calc(90% - 130px);text-align: right;border: 0;height: 20px;line-height: 20px;padding: 5px;" readonly placeholder="请选择出生年月日">
			</div>
			<div style="height: 50px;line-height: 50px;width: 100%;border-bottom: 1px solid #F6F6F6;">
				<div style="float: left;width: 50px;margin-left: 5%;font-size: 16px;">曾用名</div>
				<input v-model="formerName" :disabled="item.id?true:false" style=" font-size: 16px;margin-right: 5%;;margin-top: 10px;float: right;width: calc(90% - 60px);text-align: right;border: 0;height: 20px;line-height: 20px;padding: 5px;" placeholder="请填写调理人曾用名(多个以,分割)">
			</div>
			<div style="height: 50px;line-height: 50px;width: 100%;border-bottom: 1px solid #F6F6F6;">
				<div style="float: left;width: 80px;margin-left: 5%;font-size: 16px;">婚姻状况</div>
				<div style="font-size: 16px;margin-right: 5%;float: right;width: calc(90% - 90px);border: 0;text-align: right;">
					<el-radio :disabled="item.id?true:false" v-model="marry" label="已婚">已婚</el-radio>
					<el-radio :disabled="item.id?true:false" v-model="marry" label="未婚">未婚</el-radio>
				</div>
			</div>
			<div style="height: 50px;line-height: 50px;width: 100%;border-bottom: 1px solid #F6F6F6;">
				<div style="float: left;width: 80px;margin-left: 5%;font-size: 16px;">预约日期</div>
				<img src="../../assets/fImage/youjiantou.png" style="float: right;width: 10px;height: 10px;margin-top: 20px;margin-right: 5%;">
				<input v-model="toTime" @click="toTomeClick" style=" font-size: 16px;;margin-top: 10px;float: right;width: calc(90% - 100px);text-align: right;border: 0;height: 20px;line-height: 20px;padding: 5px;" readonly placeholder="请选择预约日期">
			</div>
		</div>
		<YunshiCalendar  
		:showCalendar="isShowTime" 
		@confirm="selectDate" 
		:type1="type"
		:isHour="false" 
		:isActive1="isActive"
		@cancel="isShowTime = false">
		</YunshiCalendar >
		<div @click="submit()" v-if="!item.id" style="margin-top: 30px;margin-left: 5%;margin-right: 5%;background-color: #00A9F2;color: white;border-radius: 5px;height: 40px;font-size: 14px;line-height: 40px;text-align: center;">
			提 交
		</div>
	</div>
</template>

<script>
	import YunshiCalendar from '../../components/yunshui-calendar/yunshuiCalendar.vue'
	import calendar from '../../components/calendar.js'
	import {conditioning} from "@/api/reservation";
	import Cookies from 'js-cookie';
	export default {
		name: "Index",
		components:{
			YunshiCalendar 
		},
		data() {
			return {
				isActive:true,
				type:'solar',
				isShowTime:false,
				lunarCalendar:'',
				birthday:'',
				name:'',
				formerName:'',
				marry:'已婚',
				phone: Cookies.get('phone'),
				toTime:'',
				item:{}
			}
		},
		created() {
			if(this.$route.query && this.$route.query.item){
				this.item = JSON.parse(this.$route.query.item)
				this.name = this.item.name
				this.birthday = this.item.birthday
				this.formerName = this.item.former_name
				this.marry = this.item.marry
				this.toTime = this.item.toTime
				this.lunarCalendar = this.item.lunar_birthday
			}
		},
		mounted() {
			if(this.$route.query && this.$route.query.item){
				this.item = JSON.parse(this.$route.query.item)
				this.name = this.item.name
				this.birthday = this.item.birthday
				this.formerName = this.item.former_name
				this.marry = this.item.marry
				this.toTime = this.item.toTime
				this.lunarCalendar = this.item.lunar_birthday
			}
		},
		activated() {
			if(this.$route.query && this.$route.query.item){
				this.item = JSON.parse(this.$route.query.item)
				this.name = this.item.name
				this.birthday = this.item.birthday
				this.formerName = this.item.former_name
				this.marry = this.item.marry
				this.toTime = this.item.toTime
				this.lunarCalendar = this.item.lunar_birthday
			}
		},
		methods: {
			selectDate(v){
				let type = v.type
				let year = v.chooseYear.value
				let month = v.chooseMonth.value>20?(v.chooseMonth.value-20):v.chooseMonth.value
				let day = v.chooseDay.value
				let flag = v.chooseMonth.value>20?true:false
				if(type == 0){
					this.birthday = year+"-"+(month<10?("0"+month):month)+"-"+(day<10?("0"+day):day)
					let lunar = calendar.calendarFormatter.solar2lunar(year,month, day);
					this.lunarCalendar = lunar.gzYear+"年"+lunar.IMonthCn+lunar.IDayCn
				}else{
					let lunar = calendar.calendarFormatter.lunar2solar(year, month, day, flag)
					this.birthday = lunar.cYear+"-"+(lunar.cMonth<10?("0"+lunar.cMonth):lunar.cMonth)+"-"+(lunar.cDay<10?("0"+lunar.cDay):lunar.cDay)
					this.lunarCalendar = lunar.gzYear+"年"+lunar.IMonthCn+lunar.IDayCn
				}
				this.isShowTime = false
			},
			showTime(v){
				this.isActive = v
				if(this.isActive){
					this.type = 'solar'
				}else{
					this.type = 'lunar'
				}
				this.isShowTime = true
			},
			birthdayClick(){
				if(!this.item.id){
					let now = new Date()
					this.$picker.show({
						type:'datePicker',
						date:'1980-01-01',
						endTime:now.getFullYear()+'-'+(now.getMonth())+'-'+now.getDate(),//截至时间
						startTime:'1900-01-01',//开始时间
						onOk:(date)=>{
							this.birthday=date;    // birthday就是所需字段，在data 里定义下
						} 
					})
				}
				
      },
			toTomeClick(){
				if(!this.item.id){
					let now = new Date()
					let nextDate = new Date();
					nextDate.setDate(now.getDate() + 1);
					let nexMonth = new Date();
					nexMonth.setDate(now.getDate() + 31);
					this.$picker.show({
						type:'datePicker',
						date:nextDate.getFullYear()+'-'+(nextDate.getMonth()+1)+'-'+nextDate.getDate(),
						endTime:nexMonth.getFullYear()+'-'+(nexMonth.getMonth()+1)+'-'+nexMonth.getDate(),//截至时间
						startTime:nextDate.getFullYear()+'-'+(nextDate.getMonth()+1)+'-'+nextDate.getDate(),//开始时间
						onOk:(date)=>{
							this.toTime=date;    // birthday就是所需字段，在data 里定义下
						} 
					})
				}
				
			},
			toIndex() {
				this.$router.push(
					{
						path:'/phone/index',
					}
				);
			},
			submit(){
				let _this = this
				if(!this.name){
					_this.$message.error("请输入调理人姓名")
					return;
				}
				if(!this.birthday){
					_this.$message.error("请选择调理人生日")
					return;
				}
				if(!this.toTime){
					_this.$message.error("请选择预约日期")
					return;
				}
				if(!this.marry){
					_this.$message.error("请选择调理人婚姻状况")
					return;
				}
				let param = {}
				param.name=this.name
				param.phone=this.phone
				param.former_name=this.formerName
				param.birthday=this.birthday
				param.marry=this.marry
				param.toTime=this.toTime
				param.lunarBirthday = this.lunarCalendar
				conditioning(param).then(data => {
						console.log(data)
						if(data.data == 1){
							_this.$message.success("预约成功")
							this.$router.push(
								{
									path:'/phone/index',
								}
							);
						}else{
							_this.$message.error("预约失败：您已预约过了")
						}
					}).catch(error =>{
						_this.$message.error(error)
					})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
</style>
